import {
    RaikoBaseDialogContentContainer, RaikoCustomSelect, raikoCustomSelectItemGenerator, RaikoGridOneColumn,
    RaikoSectionContainer,
    RaikoSimpleInputOutlined, showServerErrorMessage, showSuccessMessage
} from "@moeindal/base-raiko-panel-components";
import {useState} from "react";
import {css} from "@emotion/css";
import {PlayModeTypes} from "../../pages/games/PlayModeTypes"
import {GameService} from "../../serverService/gameService/GameService";

export default function AddNewGame({handleCloseDialog,handleAddNewGame}) {


    const [gameTitle, setGameTitle] = useState("");
    const [playMode, setPlayMode] = useState(PlayModeTypes.MULTI.id)
    const [actionButtonLoading, setActionButtonLoading] = useState(false);

    const service = new GameService();


    function handleCreateNewGame() {
        setActionButtonLoading(true)
        service.addNewGame(gameTitle,playMode)
            .then(response=>{
                handleCloseDialog()
                handleAddNewGame(response)
                showSuccessMessage("بازی جدید با موفقیت افزوده شد.")
            }).catch(reason => {
                showServerErrorMessage(reason)
        }).finally(_=>{
            setActionButtonLoading(false)
        })
    }


    return (
        <RaikoBaseDialogContentContainer>
            <RaikoSectionContainer
                title={"افزودن بازی"}
                hasActionButton
                actionButtonLoadingState={actionButtonLoading}
                actionButtonTitle={"افزودن"}
                actionButtonOnclickWithValidation={handleCreateNewGame}
                hasSecondaryButton
                secondaryButtonTitle={"بازگشت"}
                secondaryButtonOnClick={handleCloseDialog}
            >
                <RaikoGridOneColumn className={css`width: 100%`}>
                    <RaikoSimpleInputOutlined
                        labelText={"عنوان بازی"}
                        value={gameTitle}
                        setValue={setGameTitle}
                        required
                    />
                    <RaikoCustomSelect
                        labelText={"نوع بازی"}
                        value={playMode}
                        setValue={setPlayMode}
                        items={[
                            raikoCustomSelectItemGenerator(PlayModeTypes.MULTI.id, PlayModeTypes.MULTI.title),
                            raikoCustomSelectItemGenerator(PlayModeTypes.SINGLE.id, PlayModeTypes.SINGLE.title),
                        ]}
                    />
                </RaikoGridOneColumn>
            </RaikoSectionContainer>

        </RaikoBaseDialogContentContainer>
    )
}